@import (reference) '../../../../../../../../constants/spacing.module.less';

.preview-container {
  min-height: 400px;
}

.pdf-container {
  position: relative;
  width: 100%;
}

.loading-container {
  justify-content: center;
  align-items: center;
  min-height: 500px;
}

.loading {
  position: unset;
}

.error-container {
  justify-content: center;
  align-items: center;
  min-height: 200px;
  color: var(--grey-600);
}

.sample-data-note {
  margin-top: @space-8;
  color: var(--grey-600);
  font-style: italic;
}

/* react-pdf generates .react-pdf__Page__canvas internally; targeting canvas element directly */
.pdf-container canvas {
  display: block;
  margin: 0 auto;
}
